import moment from 'moment';
import { format, parse, Locale, isBefore, isValid, differenceInCalendarMonths } from 'date-fns';
import { ja } from 'date-fns/locale';
import { SearchBranch } from '../external/AggregationApi';
import { ConditionItem } from '../external/Common';
import { MasterInfoState } from '../redux/reducers/MasterInfoReducer';
import { pendingViewColumns } from '../redux/reducers/NegotiationPendingReducer';
import { SearchConditionState } from '../redux/reducers/SearchConditionReducer';
import { RegistrationProduct } from '../../../crew/src/external/CustomerBundleRegistrationApi';
import { getReplacedStringByParams } from '../utils/StringUtil';

/** モジュール */
export const MODULE = {
  /** クルーモジュール */
  CREW: 'crew',
  /** 代理店モジュール */
  AGENCY: 'agency',
  /** 営業モジュール */
  EMPLOYEE: 'employee',
  /** 顧客モジュール */
  CUSTOMER: 'customer',
};

export const LINE_TYPE = {
  PERIOD: 'periodType',
  ACTION: 'actionType',
  PROB: 'contractAccuracyType',
  RESULT: 'negotiationResultType',
  PENDING: 'holdPeriodType',
};

export const TAB_TYPE = {
  PERIOD: 'period',
  ACTION: 'action',
  PROB: 'prob',
  RESULT: 'result',
  PENDING: 'pending',
};

export const STATUS_TYPE = {
  UNDER: '01',
  DONE: '02',
  PENDING: '03',
  NO_TYPE: '',
};
export const SCROLL_TARGET_TYPE = {
  NEGOTIATION: 'negotiation',
  PRODUCT: 'product',
  ACTION: 'action',
} as const;

export const commodityCategoryContractTypeList: string[][] = [
  ['smartphoneNew', 'HS(スマホ)/新規'],
  ['smartphoneTransfer', 'HS(スマホ)/番号移行'],
  ['smartphoneMnp', 'HS(スマホ)/MNP'],
  ['smartphoneChange', 'HS(スマホ)/機変'],
  ['smartphoneContrChg', 'HS(スマホ)/契約変更'],
  ['garakeiNew', 'HS(スマホ以外)/新規'],
  ['garakeiTransfer', 'HS(スマホ以外)/番号移行'],
  ['garakeiMnp', 'HS(スマホ以外)/MNP'],
  ['garakeiChange', 'HS(スマホ以外)/機変'],
  ['garakeiContrChg', 'HS(スマホ以外)/契約変更'],
  ['tabletNew', 'タブレット/新規'],
  ['tabletTransfer', 'タブレット/番号移行'],
  ['tabletMnp', 'タブレット/MNP'],
  ['tabletChange', 'タブレット/機変'],
  ['tabletContrChg', 'タブレット/契約変更'],
  ['otherNew', 'その他/新規'],
  ['otherTransfer', 'その他/番号移行'],
  ['otherMnp', 'その他/MNP'],
  ['otherChange', 'その他/機変'],
  ['otherContrChg', 'その他/契約変更'],
  ['hikariNew', 'ソフトバンク光/新規'],
  ['hikariDiverted', 'ソフトバンク光/転用'],
  ['hikariChange', 'ソフトバンク光/事業者変更'],
  ['airNew', 'SBAir/新規'],
  ['airChange', 'SBAir/機変'],
  ['denkiNew', 'おうちでんき/新規'],
  ['denwaNew', 'おうちのでんわ/新規'],
  ['simNew', 'SIM単体/新規'],
  ['simTransfer', 'SIM単体/番号移行'],
  ['simMnp', 'SIM単体/MNP'],
  ['simChange', 'SIM単体/機変'],
  ['simContrChg', 'SIM単体/契約変更'],
];

/**
 * TODO: マスタ化したら削除
 */
export const commodityCategoryContractTypeMapping: {
  [key: string]: Array<SearchBranch>;
} = {
  '0101': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['01'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['01'],
    },
  ],
  '0102': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['01'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['02'],
    },
  ],
  '0103': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['01'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['03'],
    },
  ],
  '0104': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['01'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['04'],
    },
  ],
  '0105': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['01'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['05'],
    },
  ],
  '0201': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['02'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['01'],
    },
  ],
  '0202': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['02'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['02'],
    },
  ],
  '0203': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['02'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['03'],
    },
  ],
  '0204': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['02'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['04'],
    },
  ],
  '0205': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['02'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['05'],
    },
  ],
  '0301': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['03'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['01'],
    },
  ],
  '0302': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['03'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['02'],
    },
  ],
  '0303': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['03'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['03'],
    },
  ],
  '0304': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['03'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['04'],
    },
  ],
  '0305': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['03'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['05'],
    },
  ],
  '0401': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['04'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['01'],
    },
  ],
  '0402': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['04'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['02'],
    },
  ],
  '0403': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['04'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['03'],
    },
  ],
  '0404': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['04'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['04'],
    },
  ],
  '0405': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['04'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['05'],
    },
  ],
  '0501': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['05'],
    },
    {
      branchConditionName: 'sbHikariContractType',
      specifiedCondition: ['01'],
    },
  ],
  '0502': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['05'],
    },
    {
      branchConditionName: 'sbHikariContractType',
      specifiedCondition: ['02'],
    },
  ],
  '0503': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['05'],
    },
    {
      branchConditionName: 'sbHikariContractType',
      specifiedCondition: ['03'],
    },
  ],
  '0601': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['06'],
    },
    {
      branchConditionName: 'sbAirContractType',
      specifiedCondition: ['01'],
    },
  ],
  '0602': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['06'],
    },
    {
      branchConditionName: 'sbAirContractType',
      specifiedCondition: ['02'],
    },
  ],
  '0701': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['07'],
    },
    {
      branchConditionName: 'pwrContractType',
      specifiedCondition: ['01'],
    },
  ],
  '0801': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['08'],
    },
    {
      branchConditionName: 'landlinePhoneContractType',
      specifiedCondition: ['01'],
    },
  ],
  '0901': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['09'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['01'],
    },
  ],
  '0902': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['09'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['02'],
    },
  ],
  '0903': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['09'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['03'],
    },
  ],
  '0904': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['09'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['04'],
    },
  ],
  '0905': [
    {
      branchConditionName: 'commodityCategoryType',
      specifiedCondition: ['09'],
    },
    {
      branchConditionName: 'mobileContractType',
      specifiedCondition: ['05'],
    },
  ],
};

/**
 * TODO: マスタ化したら削除
 */
export const negotiationStatusTypeMapping: {
  [key: string]: Array<SearchBranch>;
} = {
  '01': [
    {
      branchConditionName: 'negotiationProgressType',
      specifiedCondition: ['01', '00'],
    },
  ],
  '02': [
    {
      branchConditionName: 'negotiationProgressType',
      specifiedCondition: ['02', '03', '04', '05'],
    },
  ],
};

/**
 * TODO: マスタ化したら削除
 */
export const negotiationResultTypeMapping: {
  [key: string]: Array<SearchBranch>;
} = {
  '00': [],
  '01': [
    {
      branchConditionName: 'negotiationProgressType',
      specifiedCondition: ['02'],
    },
  ],
  '02': [
    {
      branchConditionName: 'negotiationProgressType',
      specifiedCondition: ['03'],
    },
  ],
  '03': [
    {
      branchConditionName: 'negotiationProgressType',
      specifiedCondition: ['05'],
    },
  ],
  '04': [],
  '05': [
    {
      branchConditionName: 'negotiationProgressType',
      specifiedCondition: ['04'],
    },
  ],
  '06': [],
  '07': [
    {
      branchConditionName: 'negotiationProgressType',
      specifiedCondition: ['01'],
    },
  ],
  '99': [],
};

export const commodityCategoryType: string[][] = [
  ['01', 'HS(スマホ)'],
  ['02', 'HS(スマホ以外)'],
  ['03', 'タブレット'],
  ['04', 'その他'],
  ['05', 'SB光'],
  ['06', 'SBAir'],
  ['07', 'おうちでんき'],
  ['08', 'おうちのでんわ'],
  ['09', 'SIM単体'],
];

export const CONVERT_DETAIL_DISPLAY_TYPE: {
  [key: string]: { name: string; convertList: string[][] };
} = {
  COMMODITY_CATEGORY_CONTRACT_TYPE: {
    name: 'commodityCategoryContractType',
    convertList: commodityCategoryContractTypeList,
  },
  COMMODITY_CATEGORY_TYPE: {
    name: 'commodityCategoryType',
    convertList: commodityCategoryType,
  },
};

export const contractAccuracyViewColumns = [
  ['01', 'A'],
  ['02', 'B'],
  ['03', 'C'],
  ['04', 'D'],
  ['05', 'E'],
  ['00', '未入力'],
  ['total', '合計'],
];

export const periodViewColumns = [
  ['today', '当日'],
  ['tomorrow', '翌日'],
  ['week', '当週'],
  ['month', '当月'],
  ['overdue', '期日超過'],
  ['nextmonth', '翌月'],
  ['unset', '未入力'],
];

export const actionViewColumns = [
  ['01', '来店予定'],
  ['02', '架電予定'],
  ['03', '入電待ち'],
  ['00', '未入力'],
  ['total', '合計'],
];

export const negotiationResultViewColumns = [
  ['01', '成約済み'],
  ['05', '利用中'],
  ['02', '契約不成立'],
  ['03', '提案なし'],
  ['total', '合計'],
];

export const SCREEN = {
  DASHBOARD: {
    ID: 'PCMDB001',
    NAME: 'ダッシュボード',
    URL: '/',
  },
  UNDER_NEGOTIATION: {
    ID: 'PCMDB002',
    NAME: 'ステータス別：商談中',
    URL: '/UnderNegotiation',
  },
  PENDING_NEGOTIATION: {
    ID: 'PCMDB003',
    NAME: 'ステータス別：長期保留',
    URL: '/PendingNegotiation',
  },
  DONE_NEGOTIATION: {
    ID: 'PCMDB004',
    NAME: 'ステータス別：商談終了',
    URL: '/DoneNegotiation',
  },
  NEGOTIATION_SEARCH_RESULT: {
    ID: 'PCMSL001',
    NAME: '商談一覧',
    URL: '/search',
  },
  NEGOTIATION_DETAIL: {
    ID: 'PCMNG002',
    NAME: '商談情報',
    URL: '/negotiation/detail',
  },
  SUMMARY_PREVIEW: {
    ID: 'PCMNG022',
    NAME: 'サマリー',
    URL: '/summary/preview',
  },
  NEGOTIATION_CREATE: {
    ID: 'PCMNG004',
    NAME: '商談追加',
    URL: '/negotiation/edit',
  },
  PRODUCT_CREATE: {
    ID: 'PCMNG005',
    NAME: '商品追加',
    URL: '/product/edit',
  },
  ACTION_CREATE: {
    ID: 'PCMNG006',
    NAME: 'アクション追加',
    URL: '/action/edit',
  },
  CUSTOMER_DETAIL: {
    ID: 'PCMNG001',
    NAME: 'お客さま情報',
    URL: '/customer/detail',
  },
  MAIL_TOP: {
    ID: 'PCMMS001',
    NAME: 'メール',
    URL: '/mail/top',
  },
  MAIL_TEMPLATE_CONFIRM: {
    ID: 'PCMMS002',
    NAME: 'メールテンプレート内容確認',
    URL: '/mail/template/confirm',
  },
  MAIL_TEMPLATE_APPLY: {
    ID: 'PCMMS003',
    NAME: 'メールテンプレート申請',
    URL: '/mail/template/apply',
  },
  MAIL_TEMPLATE_LIST: {
    ID: 'PCMMS004',
    NAME: 'テンプレート管理',
    URL: '/mail/template/list',
  },
  MAIL_TEMPLATE_DETAIL: {
    ID: 'PCMMS005',
    NAME: 'メールテンプレート詳細',
    URL: '/mail/template/detail',
  },
  MAIL_CREATE: {
    ID: 'PCMMS006',
    NAME: 'メール作成',
    URL: '/mail/create',
  },
  MAIL_ADDRESS_SELECT: {
    ID: 'PCMMS007',
    NAME: '宛先選択',
    URL: '/mail/address/select',
  },
  MAIL_SEND: {
    ID: 'PCMMS008',
    NAME: 'メール送信内容確認',
    URL: '/mail/send',
  },
  MAIL_DETAIL: {
    ID: 'PCMMS009',
    NAME: 'メール詳細',
    URL: '/mail/detail',
  },
  MAIL_STOP: {
    ID: 'PCMMS010',
    NAME: 'メール配信停止',
    URL: '/mail/stop',
  },
  MAIL_STOP_DONE: {
    ID: 'PCMMS011',
    NAME: 'メール配信停止完了',
    URL: '/mail/stop/done',
  },
  MAIL_OPTIN: {
    ID: 'PCMMS027',
    NAME: 'メール受信の許諾画面',
    URL: '/mail/optin',
  },
  MAIL_OPTIN_DONE: {
    ID: 'PCMMS028',
    NAME: 'メール受信の許諾完了画面',
    URL: '/mail/optin/done',
  },
  MAIL_OPTIN_ERROR: {
    ID: 'PCMMS029',
    NAME: 'メール受信の許諾エラー画面',
    URL: '/mail/optin/error',
  },
  CUSTOMER_CREATE: {
    ID: 'PCMNG003',
    NAME: '顧客登録',
    URL: '/customer/edit',
  },
  MAIL_SYS_MAINTE: {
    ID: 'PCMMS013',
    NAME: 'メール配信停止システムメンテナンス',
    URL: '/mail/sysmeinte',
  },
  VISIT: {
    ID: 'PCMVR001',
    NAME: '来店予約',
    URL: '/visit',
    TAB_LIST: [
      {
        title: 'サマリー',
        type: 'summary',
        url: '/visit/summary',
      },
      {
        title: '予約一覧',
        type: 'list',
        url: '/visit/list',
      },
    ],
  },
  PROXY_LOGIN: {
    ID: 'PCMCM008',
    NAME: '代理ログイン',
    URL: '/proxylogin',
  },
};

export interface ScrollInfo {
  size: number;
  from: number;
}
export interface sortButtonStatus {
  lastUpdateDate: string;
  createDate: string;
  contractAccuracyType: string;
  actionDate: string;
}

export const SORT_TYPE = {
  // 更新日が新しい順
  LAST_UPDATE_DATE_DESC: '001',
  // 契約確率が高い順
  CONTRACT_ACCURACY_TYPE_ASC: '002',
  // アクション予定日が近い順
  ACTION_DATE_DESC: '003',
  // 更新日が古い順
  LAST_UPDATE_DATE_ASC: '101',
  // 契約確率が低い順
  CONTRACT_ACCURACY_TYPE_DESC: '102',
  // アクション予定日が遠い順
  ACTION_DATE_ASC: '103',
  // 作成日が新しい順
  CREATE_DATE_DESC: '004',
  // 作成日が古い順
  CREATE_DATE_ASC: '104',
};

export const DEFAULT_PAGE_VIEW = {
  RECORD_ROWS: 10,
  CURRENT_PAGE: 1,
  API_UPDATE_INDEX: 11,
};

export interface SimpleDictionary {
  [key: string]: string;
}

// 画面表示上の日本語とキーの対応定義
export const DISPLAY_NAMES: SimpleDictionary = {
  keyword: 'フリーワード',

  dateCategory: '期間指定',
  createDate: '初回登録日',
  latestUpdateDate: '最終更新日',
  actionDate: 'アクション予定日',
  callDate: '架電予定日',
  comeDate: '来店予定日',
  commodityCategoryContractType: '商材カテゴリ契約区分',
  commodityCategoryType: '商材カテゴリ区分',

  period: '対象期間',

  smartphone: 'HSスマホ',
  telephone: 'HSスマホ以外',
  accessary: '副商材',

  today: '当日',
  tomorrow: '翌日',
  week: '当週',
  month: '当月',
  nextmonth: '翌月',
  overdue: '期日超過',
  unset: '未入力',
  '3rdMonth': '翌々月',
  '4thMonth': '翌々々月',
  '5thMonth': '翌々々々月',

  smartphoneNew: 'HSスマホ 新規',
  smartphoneTransfer: 'HSスマホ 番号移行',
  smartphoneChange: 'HSスマホ 機種変更',
  smartphoneMnp: 'HSスマホ MNP',
  smartphoneContrChg: 'HSスマホ 契約変更',
  garakeiNew: 'HSスマホ以外 新規',
  garakeiTransfer: 'HSスマホ以外 番号移行',
  garakeiChange: 'HSスマホ以外 機種変更',
  garakeiMnp: 'HSスマホ以外 MNP',
  garakeiContrChg: 'HSスマホ以外 契約変更',
  tabletNew: 'タブレット 新規',
  tabletTransfer: 'タブレット 番号移行',
  tabletChange: 'タブレット 機種変更',
  tabletMnp: 'タブレット MNP',
  tabletContrChg: 'タブレット 契約変更',
  otherNew: 'その他 新規',
  otherTransfer: 'その他 番号移行',
  otherChange: 'その他 機種変更',
  otherMnp: 'その他 MNP',
  otherContrChg: 'その他 契約変更',
  hikariNew: 'ソフトバンク光 新規',
  hikariDiverted: 'ソフトバンク光 転用',
  hikariChange: 'ソフトバンク光 事業者変更',
  airNew: 'ソフトバンクAir 新規',
  airChange: 'ソフトバンクAir 機種変更',
  denwaNew: 'おうちのでんわ 新規',
  denkiNew: 'おうちでんき 新規',
  simNew: 'SIM単体 新規',
  simTransfer: 'SIM単体 番号移行',
  simChange: 'SIM単体 機種変更',
  simMnp: 'SIM単体 MNP',
  simContrChg: 'SIM単体 契約変更',

  statusType: 'ステータス',
  negotiationStatus: '商談ステータス',
  done: '商談終了',
  pending: '長期保留',
  doing: '商談中',

  holdPeriodType: '保留期間',
  actionType: '次アクション',
  periodType: '対応期間',
  contractAccuracyType: '契約確率',
  negotiationResultType: '商談結果',

  // 検索で使用する項目を追加
  // 顧客
  customerFullName: 'お客さま氏名',
  customerKanaFullName: 'お客さま指名ふりがな',
  customerId: 'お客さま番号',
  familyStructureType: '家族構成',
  contactMsn: '連絡先',

  // 商談
  closingSalesmanCd: '担当者クルーコード',
  closingSalesmanName: '担当者',
  //アクションは上で定義済み
  tempCd1: '臨時コード①',
  tempCd: '臨時コード（その他）',
  //商材カテゴリは上で定義済み
  registerReasonType: '対応内容',
  projectCd: '案件名',
  //商談ステータスは上で定義済み
  //契約確率は上で定義済み

  // モバイル
  wrkType: '受付内容',
  mobileConsiderNumType: '検討台数',

  // SB光
  wrkTypeSbb: '受付内容',

  detail_commodityType: '詳細条件（仮）',
};

export const DISPLAY_NAMES_STATUS_TYPE: SimpleDictionary = {
  '01': '商談中',
  '02': '商談終了',
  '03': '長期保留',
};

// 詳細条件設定に表示する searchCondition の項目
export const DETAIL_SEARCH_CONDITION_KEYS = [
  'statusType',
  'commodityCategoryContractType',
  'detail_commodityType',
  'period',
  'action',
  'probability',
  'negotiationResult',
  'negotiationStatus',
  'holdPeriodType',
  'actionType',
  'periodType',
  'contractAccuracyType',
  'negotiationResultType',
  'holdPeriodType',
  'commodityCategoryType',
];

// パーミッションモーダルの種別
export const PERMISSION_MODAL_TYPE = {
  // 情報保持許諾
  INFORMATION_RETENTION: 'A',
  // 情報更新許諾
  INFORMATION_EDIT: 'B',
} as const;
export type PermissionModalType = typeof PERMISSION_MODAL_TYPE[keyof typeof PERMISSION_MODAL_TYPE];

// 許諾種類
export const PERMISSION_TYPE = {
  // 対面
  FACE_TO_FACE: '01',
  // 非対面
  NON_FACE_TO_FACE: '02',
  // 情報修正
  EDIT_INFO: '03',
  // その他
  OTHER: '04',
} as const;
export type PermissionType = typeof PERMISSION_TYPE[keyof typeof PERMISSION_TYPE];

/**
 * 検索条件の文字列を作成する
 *
 * @param conditionName
 * @param specifiedConditions
 */
export function makeSearchConditionDisplayStr(condition: ConditionItem) {
  const conditionName: string = condition.branchConditionName;
  const conditionTitle: string = DISPLAY_NAMES[conditionName] ? DISPLAY_NAMES[conditionName] : conditionName;

  switch (conditionName) {
    case 'createDate':
    case 'latestUpdateDate':
    case 'actionDate':
    case 'callDate':
    case 'comeDate':
      return `${conditionTitle}:${condition.specifiedCondition.join('-')}`;
    default:
      return `${conditionTitle}:${condition.specifiedCondition
        .map((item) => getSpecifiedConditionName(conditionName, item ? item : ''))
        .join(',')}`;
  }
}

export function getSpecifiedConditionName(conditionName: string, specifiedCondition: string): string {
  let dic: SimpleDictionary = {};
  switch (conditionName) {
    case 'contractAccuracyType':
      dic = viewColumnsToDic(contractAccuracyViewColumns);
      break;
    case 'periodType':
      dic = viewColumnsToDic(periodViewColumns);
      break;
    case 'actionType':
      dic = viewColumnsToDic(actionViewColumns);
      break;
    case 'negotiationResultType':
      dic = viewColumnsToDic(negotiationResultViewColumns);
      break;
    case 'holdPeriodType':
      dic = viewColumnsToDic(pendingViewColumns);
      break;
    case 'statusType':
      dic = DISPLAY_NAMES_STATUS_TYPE;
      break;
    case CONVERT_DETAIL_DISPLAY_TYPE.COMMODITY_CATEGORY_CONTRACT_TYPE.name:
      dic = viewColumnsToDic(CONVERT_DETAIL_DISPLAY_TYPE.COMMODITY_CATEGORY_CONTRACT_TYPE.convertList);
      break;
    case CONVERT_DETAIL_DISPLAY_TYPE.COMMODITY_CATEGORY_TYPE.name:
      dic = viewColumnsToDic(CONVERT_DETAIL_DISPLAY_TYPE.COMMODITY_CATEGORY_TYPE.convertList);
      break;
    default:
      dic = DISPLAY_NAMES;
      break;
  }
  return dic[specifiedCondition] ? dic[specifiedCondition] : specifiedCondition;
}

function viewColumnsToDic(columns: string[][]): SimpleDictionary {
  const dic: SimpleDictionary = {};
  columns.forEach((item) => {
    dic[item[0]] = item[1];
  });
  return dic;
}

/**
 * 2つの検索条件が一致しているかどうかを判定する.
 *
 * @param a 検索条件1
 * @param b 検索条件2
 */
export function isSameSearchCondition(a: SearchConditionState, b: SearchConditionState): boolean {
  if (a === b) {
    return true;
  }
  if (Object.keys(a).length != Object.keys(b).length) {
    return false;
  }

  for (let i = 0; i < a.length; i++) {
    const iIndex = getFindIndex(b, a[i].searchConditionName);

    // aにある検索条件がbに存在しない場合、falseを返却
    if (iIndex === -1) {
      return false;
    } else {
      if (
        a[i].searchConditionGroupId !== b[iIndex].searchConditionGroupId ||
        compareSpecifiedCondition(a[i].specifiedCondition, b[iIndex].specifiedCondition)
      ) {
        return false;
      }
    }
  }

  return true;
}

/**
 *
 * @param specifiedConditionA
 * @param specifiedConditionB
 *
 * @returns
 * 指定条件が異なる場合、Trueを返却する。
 * 指定条件が同じ場合、Falseを返却する。
 */
function compareSpecifiedCondition(specifiedConditionA: (string | null)[], specifiedConditionB: (string | null)[]): boolean {
  // Step1. AとB配列の長さが異なるとTrueを返却する
  if (specifiedConditionA.length !== specifiedConditionB.length) {
    return true;
  }

  for (let i = 0; i < specifiedConditionA.length; i++) {
    if (specifiedConditionA[i] !== specifiedConditionB[i]) {
      return true;
    }
  }

  return false;
}

/**
 * 詳細設定条件に該当する大分類名を返却する。
 *
 * @param conditionName 詳細設定条件名
 * @returns             大分類名
 */
export function getCategoryName(conditionName: string): string {
  // TODO .containsを使いたい！
  switch (conditionName) {
    case 'customerFullName':
    case 'customerKanaFullName':
    case 'customerId':
    case 'familyStructureType':
    case 'contactMsn':
      return '顧客';

    case 'closingSalesmanCd':
    case 'closingSalesmanName':
    case 'actionType':
    case 'tempCd1':
    case 'tempCd':
    case 'comodityCategoryType':
    case 'registerReasonType':
    case 'projectCd':
    case 'contractAccuracyType':
    case 'statusType':
      return '商談';

    case 'wrkType':
    case 'mobileConsiderNumType':
      return 'モバイル';

    default:
      return '';
  }
}

export const AUTH_ROLE: {
  [key: string]: {
    name: string;
    isBillcstmDisplay: boolean;
    isMngcstmDisplay: boolean;
  };
} = {
  '0600': {
    name: '広域代理店閲覧者',
    isBillcstmDisplay: true,
    isMngcstmDisplay: true,
  },
  '0601': {
    name: '広域代理店責任者',
    isBillcstmDisplay: true,
    isMngcstmDisplay: true,
  },
  '0610': {
    name: '一次代理店閲覧者',
    isBillcstmDisplay: false,
    isMngcstmDisplay: true,
  },
  '0611': {
    name: '一次代理店責任者',
    isBillcstmDisplay: false,
    isMngcstmDisplay: true,
  },
  '0620': {
    name: '法人閲覧者',
    isBillcstmDisplay: false,
    isMngcstmDisplay: true,
  },
  '0621': {
    name: '法人責任者',
    isBillcstmDisplay: false,
    isMngcstmDisplay: true,
  },
  '0630': {
    name: '運営店閲覧者',
    isBillcstmDisplay: false,
    isMngcstmDisplay: false,
  },
  '0631': {
    name: '運営店責任者',
    isBillcstmDisplay: false,
    isMngcstmDisplay: false,
  },
};

export const CATEGORY_VALIDATION: {
  [key: string]: {
    validation: RegExp;
    editMessage: string;
  };
} = {
  number: { validation: /^[0-9]*$/, editMessage: '数字のみ入力できます。' },
  tel: { validation: /^([0-9]{0,11})$/, editMessage: '数字のみ入力できます。' },
  halfSize: {
    validation: /^([a-zA-Z0-9])*$/,
    editMessage: '半角英数字のみ入力できます。',
  },
};

export const SESSION_DISCONNECT = 'SessionDisconnect';

export const CUSTOMER_NAME_INFO_LIST = [
  {
    type: '0',
    name: '漢字',
  },
  {
    type: '1',
    name: '英字',
  },
  {
    type: '2',
    name: '法人',
  },
];

export const ACTION_TAG: {
  [key: string]: {
    name: string;
    icon: string;
  };
} = {
  '01': {
    name: '来店',
    icon: 'store',
  },
  '02': {
    name: '架電',
    icon: 'phone_forwarded',
  },
  '03': {
    name: '受電待ち',
    icon: 'phone_missed',
  },
};

export const DAY_TYPE: {
  [key: string]: {
    name: string;
  };
} = {
  '0': {
    name: '日付予定なし',
  },
  '1': {
    name: '平日',
  },
  '2': {
    name: '休日',
  },
  '3': {
    name: '日付指定',
  },
};

export const ACTION_TIME_TYPE: {
  [key: string]: {
    name: string;
  };
} = {
  '01': {
    name: '時間指定',
  },
  '02': {
    name: 'AM',
  },
  '03': {
    name: 'PM',
  },
};

export enum ACTION_TYPE {
  /** 未入力 */
  NOT_ENTERED = '00',
  /** 来店予定 */
  SCHEDULED_TO_VISIT = '01',
  /** 架電予定 */
  CALL_SCHEDULE = '02',
  /** 入電待ち */
  WAITING_FOR_INCOMING_CALL = '03',
}

export enum NEGOTIATION_STATUS_TYPE {
  /** 商談中 */
  IN_NEGOTIATION = '01',
  /** 商談終了 */
  NEGOTIATION_END = '02',
  /** その他 */
  OTHER = '99',
}

export enum NEGOTIATION_RESULT_TYPE {
  /** 未入力 */
  NOT_ENTERED = '00',
  /** 契約成立 */
  SATISFIED = '01',
  /** 契約不成立 */
  UNSATISFIED = '02',
  /** 提案前 */
  BEFORE_PROPOSAL = '03',
  /** 仮登録中 */
  IN_TEMPORARY_REGISTRATION = '04',
  /** 利用中 */
  USING = '05',
  /** メール送信済 */
  EMAIL_SENT = '06',
  /** 商談中 */
  IN_NEGOTIATION = '07',
  /** その他 */
  OTHER = '99',
}

export enum CONTRACT_ACCURACY_TYPE {
  /** 未入力 */
  NOT_ENTERED = '00',
  /** A */
  A = '01',
  /** B */
  B = '02',
  /** C */
  C = '03',
  /** D */
  D = '04',
  /** E */
  E = '05',
  /** その他 */
  OTHER = '99',
}

export enum COMMODITY_CATEGORY_TYPE {
  /** スマホ */
  SMARTPHONE = '01',
  /** スマホ以外 */
  HS_EXCEPT_SMARTPHONES = '02',
  /** タブレット */
  TABLET = '03',
  /** その他（モバイル） */
  MOBILE_OTHER = '04',
  /** SB光 */
  SOFTBANK_HIKARI = '05',
  /** SBAir */
  SOFTBANK_AIR = '06',
  /** おうちでんき */
  ELECTRICITY = '07',
  /** おうちのでんわ */
  HOME_PHONE = '08',
  /** SIM単体*/
  SIM_ONLY = '09',
  /** その他 */
  ALL_OTHER = '99',
  /** 未選択 */
  NOT_ENTERED = '00',
}

export const COMMODITY_CATEGORY_TYPE_DIC: {
  [key: string]: {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE;
  };
} = {
  '01': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.SMARTPHONE,
  },
  '02': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.HS_EXCEPT_SMARTPHONES,
  },
  '03': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.TABLET,
  },
  '04': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.MOBILE_OTHER,
  },
  '05': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.SOFTBANK_HIKARI,
  },
  '06': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.SOFTBANK_AIR,
  },
  '07': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.ELECTRICITY,
  },
  '08': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.HOME_PHONE,
  },
  '09': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.SIM_ONLY,
  },
  '99': {
    commodityCategoryType: COMMODITY_CATEGORY_TYPE.ALL_OTHER,
  },
};

export const arrayInternetAndLandLine: COMMODITY_CATEGORY_TYPE[] = [
  COMMODITY_CATEGORY_TYPE.SOFTBANK_HIKARI,
  COMMODITY_CATEGORY_TYPE.SOFTBANK_AIR,
  COMMODITY_CATEGORY_TYPE.HOME_PHONE,
];

export const arrayMobile: COMMODITY_CATEGORY_TYPE[] = [
  COMMODITY_CATEGORY_TYPE.SMARTPHONE,
  COMMODITY_CATEGORY_TYPE.HS_EXCEPT_SMARTPHONES,
  COMMODITY_CATEGORY_TYPE.TABLET,
  COMMODITY_CATEGORY_TYPE.MOBILE_OTHER,
  COMMODITY_CATEGORY_TYPE.SIM_ONLY,
];

export const COMMODITY_CATEGORY_TAG: {
  [key: string]: {
    name: string;
    icon: string;
  };
} = {
  '01': {
    name: 'HS（スマホ）',
    icon: 'phone_iphone',
  },
  '02': {
    name: 'HS（スマホ以外）',
    icon: 'phone_iphone',
  },
  '03': {
    name: 'タブレット',
    icon: 'phone_iphone',
  },
  '04': {
    name: 'その他',
    icon: 'phone_iphone',
  },
  '05': {
    name: 'SB光',
    icon: 'language',
  },
  '06': {
    name: 'SBAir',
    icon: 'language',
  },
  '07': {
    name: 'おうちでんき',
    icon: 'lightbulb_outline',
  },
  '08': {
    name: 'おうちのでんわ',
    icon: 'language',
  },
  '09': {
    name: 'SIM単体',
    icon: 'phone_iphone',
  },
  '99': {
    name: 'その他',
    icon: 'devices_other',
  },
};

/** 商材ブランド */
export const COMMODITY_BRAND = {
  /** 商材ブランド:SB */
  SB: '1',
  /** 商材ブランド:YM */
  YM: '4',
} as const;
export type CommodityBrand = typeof COMMODITY_BRAND[keyof typeof COMMODITY_BRAND];

export enum REGISTERED_FROM_TYPE {
  /** 新見込 */
  NEW_POTENTIAL = '0',
  /** 旧見込 */
  OLD_POTENTIAL = '1',
  /** BSW */
  BSW = '2',
}

export enum FILE_TYPE {
  /** ご案内書類 */
  INFORMATION_DOCUMENT = '01',
  /** 見積書PDF */
  CNCG_ODR_PDF = '02',
}

/* 見積書連携ステータス */
export enum CNCG_STATUS {
  /** 未ステータス（商談添付画像の場合はESB連携しないため、こちらで固定） */
  NO_STATUS = '0',
  /** ESB連携待ち（見積書PDFの場合はESB連携待ちなのでこちら） */
  NOT_LINKED_TO_ESB = '1',
  /** 2:ESB連携済（見積書PDFの場合） */
  LINKED_TO_ESB = '2',
}

export enum FAMILY_STRUCTURE_INFO_TYPE {
  /** 利用中キャリア */
  USING_CARRIER = '01',
  /** 割引 */
  DISCOUNT = '02',
}

export enum FAMILY_STRUCTURE_INFO_ITEM {
  /** 他社携帯利用中 */
  OTHER_USE = '0101',
  /** SB携帯利用中 */
  SB_USE = '0102',
  /** YM携帯利用中 */
  YM_USE = '0103',
  /** LINEMO携帯利用中 */
  LINEMO_USE = '0104',
  /** おうち割申込済 */
  OTOKU_USE = '0201',
}

export enum DESTINATION_TYPE {
  /** メールを送信しない */
  NOT_SEND = '000',
  /** SB/YM電話番号あてにメールを送信 */
  SEND_TO_CALL = '001',
  /** メールアドレスあてにメールを送信 */
  SEND_TO_MAIL = '002',
}

export enum SEND_TO_CALL_TYPE {
  /** 日中連絡先 */
  DAYTIME_CONTACT = '001',
  /** 緊急連絡先 */
  EMERGENCY_CONTACT = '002',
}

export enum DESTINATION_TYPE_FOR_RESERVE {
  /** 送信なし */
  NOT_SEND = 'N',
  /** MMS送信 */
  SEND_TO_CALL = 'S',
  /** Email送信 */
  SEND_TO_MAIL = 'E',
}

/**
 * @deprecated @common/src/redux/reducers/MasterInfoReducer/DisplayItemId に移行
 */
export enum DISPLAY_ITEM_ID {
  /** 利用中キャリア */
  USING_MOBILE_CARRIER = 'ITEM00008',
  /** 利用中機種 */
  USING_MOBILE_KINDS_NAME = 'ITEM00010',
  /** モバイル更新月 */
  MOBILE_UPD_YEAR_MONTH = 'ITEM00011',
  /** 割賦残債 */
  MOBILE_INSTALL_MONTHLY_PAYMENT = 'ITEM00014',
  /** 割賦残債終了年月 */
  MOBILE_INSTALL_END_YEAR_MONTH = 'ITEM00015',
  /** お住まい */
  HOUSING_TYPE = 'ITEM00026',
  /** エリアチェック結果 */
  INFORMATION_PROVISION_STATUS = 'ITEM00027',
  /** 固定回線の状態 */
  LANDLINE_PHONE_USAGE_STATUS = 'ITEM00028',
  /** 固定回線状態（SB光） */
  FIXED_LINE_STATUS_SB_HIKARI = 'ITEM00228',
  /** 利用中のネット環境 */
  USING_HOME_INTERNET_TYPE = 'ITEM00029',
  /** NTT116確認結果 */
  INTERNETLINE_CONTRACT_HOLDER = 'ITEM00031',
  /** 契約中回線事業者 */
  USING_INTERNETLINE_PROVIDER = 'ITEM00032',
  /** 契約中回線事業者備考欄 */
  USING_INTERNETLINE_PROVIDER_REMARKS = 'ITEM00033',
  /** 契約中プロバイダ */
  USING_LANDLINE_PHONE_PROVIDER = 'ITEM00034',
  /** 契約中プロバイダ備考欄 */
  USING_LANDLINE_PHONE_PROVIDER_REMARKS = 'ITEM00035',
  /** 契約更新月（インターネット・固定電話） */
  USING_INTERNETLINE_UPD_YEAR_MONTH = 'ITEM00036',
  /** 現在の電力事業者 */
  USING_PWR_PROVIDER = 'ITEM00045',
  /** 現在の電力事業者（その他） */
  USING_PWR_PROVIDER_NAME = 'ITEM00046',
  /** 電気料金月 */
  USING_PWR_MONTH = 'ITEM00047',
  /** 電気料金金額 */
  USING_PWR_MONTH_CHARGE = 'ITEM00048',
  /** お住まい（おうちでんき） */
  USING_PWR_HOUSING_TYPE = 'ITEM00049',
  /** 契約形態（モバイル） */
  CONTRACT_TYPE_MOBILE = 'ITEM00054',
  /** 契約形態（SB光） */
  CONTRACT_TYPE_HIKARI = 'ITEM00055',
  /** 契約形態（Air） */
  CONTRACT_TYPE_AIR = 'ITEM00056',
  /** 契約形態（おうちのでんわ） */
  CONTRACT_TYPE_HOME = 'ITEM00060',
  /** 契約形態（おうちでんき） */
  CONTRACT_TYPE_PWR = 'ITEM00061',
  /** 割賦残債（1-24回） */
  USING_MOBILE_INSTALL_MONTHLY_PAYMENT_EARLY = 'ITEM00062',
  /** 特典利用開始日 */
  CAMPAIGN_START_MONTH = 'ITEM00063',
  /** 残債金額 */
  MOBILE_BALANCE = 'ITEM00075',
  /** 加入特典 */
  SUBSCRIPTION_BENEFITS = 'ITEM00076',
  /** 光セット */
  HIKARI_SET = 'ITEM00078',
  /** でんきセット */
  DENKI_SET = 'ITEM00079',
  /** スマートログイン設定 */
  SMART_LOGIN_SETTING = 'ITEM00080',
  /** MSN設定 */
  MSN_SETTING = 'ITEM00081',
  /** 契約確率 */
  CONTRACT_ACCURACY_TYPE = 'ITEM00082',
  /** メールアドレス */
  CUSTOMER_EMAIL_SUFFIX = 'ITEM00084',
  /** 家族構成 */
  FAMILY_INFORMATION = 'ITEM00085',
  /** メール送信先 */
  DESTINATION_TYPE = 'ITEM00086',
  /** 本人確認書類 */
  IDENTITY_VERIFICATION_DOCUMENT_TYPE = 'ITEM00087',
  /** 見込理由 */
  REGISTER_REASON_TYPE = 'ITEM00112',
  /** 見込理由（その他メモ） */
  REGISTER_REASON_TYPE_CONTENTS = 'ITEM00113',
  /** 在留期限年 */
  STAY_DEADLINE = 'ITEM00139',
  /** アクション予定時間FROM */
  ACTION_TIME_FROM_HOUR = 'ITEM00140',
  /** アクション予定時間TO */
  ACTION_TIME_TO_HOUR = 'ITEM00141',
  /** アクション予定時間FROM_架電 */
  ACTION_TIME_FROM_HOUR_K = 'ITEM00223',
  /** アクション予定時間TO_架電 */
  ACTION_TIME_TO_HOUR_K = 'ITEM00224',
  /** アクション完了時間 */
  ACTION_COMPLETE_TIME_HOUR = 'ITEM00142',
  /** アクション予定分FROM */
  ACTION_TIME_FROM_MINUTE = 'ITEM00143',
  /** アクション予定分TO */
  ACTION_TIME_TO_MINUTE = 'ITEM00144',
  /** アクション完了分 */
  ACTION_COMPLETE_TIME_MINUTE = 'ITEM00145',
  /** アクション対応結果 */
  ACTION_STATUS_TYPE = 'ITEM00146',
  /** その他追加書類 */
  OTHER_VERIFICATION_DOCUMENT_TYPE = 'ITEM00148',
  /** 商談ステータス */
  NEGOTIATION_PROGRESS_TYPE = 'ITEM00149',
  /** 契約予定名義 */
  CONTRACTOR_TYPE = 'ITEM00150',
  /** 支払終了月（1-24回） */
  USING_MOBILE_INSTALL_END_YEAR_MONTH_EARLY = 'ITEM00151',
  /** 取り置きメモ */
  KEEP_NOTE = 'ITEM00153',
  /** 業務：契約形態（その他） */
  CONTRACT_TYPE_OTHER = 'ITEM00154',
  /** 業務（その他） */
  OTHER_PRODUCT_BUSINESS_NOTE = 'ITEM00155',
  /** 対応ステータス */
  OTHER_PRODUCT_ACTION_STATUS_TYPE = 'ITEM00156',
  /** 希望プラン（おうちでんき） */
  PWR_HOPE_PRICE_PLAN = 'ITEM00157',
  /** 希望機種有無（未決定メモ） */
  HOPE_KINDS_REMARKS = 'ITEM00158',
  /** 送信先のSB/YM電話番号 */
  SEND_SB_YM_NUMBER = 'ITEM00169',
  /** 一斉送信メール */
  SEND_BULK_MAIL = 'ITEM00170',
  /** Y!Mobileサービスの初期設定 */
  YM_SERVICE_INITIAL_SETTING = 'ITEM00171',
  /** 商材カテゴリ */
  COMMODITY_CATEGORY = 'ITEM00181',
  /** ご利用状況：利用中キャリア（その他） */
  USING_MOBILE_CARRIER_TEXT = 'ITEM00065',
  /** ご利用状況：利用中機種：機種タイプ */
  USING_MOBILE_KIND_TYPE = 'ITEM00009',
  /** ご利用状況：利用中機種：機種名 */
  USING_MOBILE_KIND_NAME = 'ITEM00010',
  /** ご利用状況：請求群 */
  USING_MOBILE_BILLING_GROUP_TYPE = 'ITEM00012',
  /** ご利用状況：毎月のお支払い金額 */
  USING_MOBILE_MONTHLY_PAYMENT = 'ITEM00013',
  /** ご希望の内容：希望機種有無 */
  HOPE_KINDS_FLG = 'ITEM00072',
  /** ご希望の内容：希望機種タイプ */
  HOPE_KINDS_TYPE = 'ITEM00152',
  /** ご希望の内容：希望機種名 */
  HOPE_KINDS_NAME = 'ITEM00002',
  /** ご希望の内容：取り置き */
  KEEP_TYPE = 'ITEM00058',
  /** ご希望の内容：料金プラン */
  PRICE_PLAN = 'ITEM00003',
  /** ご希望の内容：料金プラン(YM) */
  YM_PRICE_PLAN = 'ITEM00159',
  /** ご希望の内容：パケットサービス */
  PACKET_DSCT_SERVICE = 'ITEM00004',
  /** ご希望の内容：店頭スマホサポート */
  SMART_PHONE_SET_SUPPORT = 'ITEM00073',
  /** ご希望の内容：店頭スマホサポート(その他) */
  SMART_PHONE_SET_SUPPORT_TEXT = 'ITEM00074',
  /** その他：特記事項 */
  PRODUCT_NOTICE_AGE_CHECK = 'ITEM00147',
  /** 割賦前半終了回数*/
  USING_MOBILE_INSTALL_EARLY_LAST_COUNT = 'ITEM00232',
}

export enum MESSAGETYPE {
  NORMAL = 'NORMAL',
  OPRATE = 'OPRATE',
}

/**
 * @deprecated @common/src/redux/reducers/MasterInfoReducer/MessageMasterKeys に移行
 */
export enum MESSAGE {
  /** 個別設定 */
  CUSTOM = 'CUSTOM',
  /** 該当する商談で絞り込んでいます */
  I_012 = 'I_012',
  /** 入力内容を保存しました */
  I_013 = 'I_013',
  /** {0}を削除しました */
  I_014 = 'I_014',
  /** メールを送信しました */
  I_015 = 'I_015',
  /** テンプレートを申請しました */
  I_016 = 'I_016',
  /** テンプレートを下書き保存しました */
  I_017 = 'I_017',
  /** 該当するメールで絞り込んでいます */
  I_021 = 'I_021',
  /** アクションが登録上限数（6件）です。不要なアクションを削除してから、新しく追加してください。 */
  I_022 = 'I_022',
}

export const isCloseAction = (actionStatusType?: string): boolean => {
  return actionStatusType ? actionStatusType.substr(2, 1) === '9' : false;
};

/**
 * @deprecated stringDateToFormatString()へ移行する
 * * 代1引数としてよく使われるDate.toLocaleStringをこれから使用禁止とするため(クライアント環境依存関数のため)
 * * ライブラリmomentが非推薦となったためdate-fnsへ移行
 * * https://momentjs.com/docs/#/-project-status/
 */
export const formatDate = (dateStr: string, formatFrom: string, formatTo: string): string => {
  if (!dateStr || !formatFrom || !formatTo) {
    return '';
  }
  return moment(dateStr, formatFrom).format(formatTo);
};

/**
 * @deprecated stringDateToFormatString()へ移行する
 * * 代1引数としてよく使われるDate.toLocaleStringをこれから使用禁止とするため(クライアント環境依存関数のため)
 * * ライブラリmomentが非推薦となったためdate-fnsへ移行
 * * https://momentjs.com/docs/#/-project-status/
 * * eslintでnull!警告
 */
export const formatDateNull = (dateStr: string, formatFrom: string, formatTo: string): string => {
  if (!dateStr || !formatFrom || !formatTo) {
    // TODO lintで警告が出る。⇨使ってる箇所が多く、影響が大きいため後回し
    return null!;
  }
  return moment(dateStr, formatFrom).format(formatTo);
};

/**
 * Date型から指定のフォーマットの文字列へ変換
 * @param date
 * @param toFormat
 * @param locale デフォルトja
 * @returns
 */
export const dateToFormatString = (date: Date | undefined, toFormat: string, locale: Locale = ja): string => {
  if (!date) {
    return '';
  }

  return format(date, toFormat, { locale });
};

/**
 * 文字列型の日付から指定のフォーマットの文字列へ変換
 * @param stringDate
 * @param fromFormat
 * @param toFormat
 * @param locale デフォルトja
 * @returns string
 */
export const stringDateToFormatString = (stringDate: string, fromFormat: string, toFormat: string, locale: Locale = ja): string => {
  const date = parse(stringDate, fromFormat, new Date());
  if (isInvalidDate(date)) {
    return '';
  }

  return dateToFormatString(parse(stringDate, fromFormat, new Date()), toFormat, locale);
};

/**
 * Date型のInvalid Date判定
 * @param date
 * @returns
 */
export const isInvalidDate = (date: Date | undefined) => {
  return date ? Number.isNaN(date.getTime()) : true;
};

/**
 * Date型過去日判定
 * @param date1
 * @param date2
 * @returns
 */
export const isPastDay = (date1: Date, date2: Date): boolean => {
  return isBefore(date1.setHours(0, 0, 0, 0), date2.setHours(0, 0, 0, 0));
};

/**
 * @deprecated @common/src/redux/reducers/MasterInfoReducer/MasterInfoStateUtils に移行
 */
export const getPcmCdNmFromMasterInfo = (masterInfo: MasterInfoState, displayItemId: DISPLAY_ITEM_ID, pcmCd: string): string => {
  // 画面項目IDを元にPCMコード区分取得
  const pcmCdDivision = masterInfo.displayItemList.find(
    (displayItem) => displayItem.displayItemId === displayItemId
  )?.setValuePcmCdDivision;
  // PCMコード区分及びPCMコードを元にPCMコード名称取得
  const pcmCdNm = masterInfo.pcmCodeDivisionList
    .find((pcm) => pcm.pcmCdDivision === pcmCdDivision)
    ?.pcmCodeList.find((pcm) => pcm.pcmCd === pcmCd)?.pcmCdNm;
  return pcmCdNm ? pcmCdNm : '';
};

/**
 * @deprecated @common/src/redux/reducers/MasterInfoReducer/MasterInfoStateUtils に移行
 */
export const getMessageFromMasterInfo = (masterInfo: MasterInfoState, messageId: string): string => {
  if (!masterInfo) {
    return '';
  }
  if (!masterInfo.messageList) {
    return '';
  }

  // MessageInfo取得
  const messageInfo = masterInfo.messageList.find((messageItem) => messageItem.messageId === messageId);
  return messageInfo ? messageInfo.message : '';
};

export const getInquiryToday = (jobDateTime?: string): Date => {
  if (jobDateTime) {
    const dStr = jobDateTime.replace(/^([0-9]{4})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})([0-9]{2})$/, '$1/$2/$3 $4:$5:$6');
    const d = new Date(dStr);
    if (!isNaN(d.getTime())) {
      return d;
    }
  }
  return new Date();
};

export enum DATE_YYYYMMDD {
  MIN = '19000101',
  MAX = '99991231',
}

export const getSystemNameBySystemCd = (systemCd: string): string => {
  switch (systemCd) {
    case 'M00002':
      return 'GINIE';

    case 'M00500':
      return '来店予約';

    case 'M00807':
      return '料金シミュレータ';

    default:
      return systemCd;
  }
};

export function getSpecifiedCondition(searchCondition: SearchConditionState, searchBranchName: string): (string | null)[] {
  const findIndex = getFindIndex(searchCondition, searchBranchName);
  return findIndex !== -1 ? searchCondition[findIndex].specifiedCondition : [];
}

export function getFindIndex(searchCondition: SearchConditionState, searchBranchName: string): number {
  return searchCondition.findIndex((element) => element.searchConditionName === searchBranchName);
}

/**
 * 指定した日付間の経過月数を取得する
 * @param d1 チェックしたい開始日付
 * @param d2 チェックしたい終了日付
 * @returns 月の比較計算結果
 */
export const countDiffMonth = (d1?: Date, d2?: Date): string => {
  if (!d1 || !d2 || !isValid(d1) || !isValid(d2)) {
    return '';
  }

  const months = Math.abs(differenceInCalendarMonths(d2, d1)) + 1;
  return months.toString();
};

export const NEGOTIATION_PROGRESS_TYPE = {
  /** 未入力 */
  NOT_ENTERED: '00',
  /** 商談中 */
  IN_NEGOTIATION: '01',
  /** 契約成立 */
  SATISFIED: '02',
  /** 契約不成立 */
  UNSATISFIED: '03',
  /** 利用中 */
  USING: '04',
  /** 提案前 */
  BEFORE_PROPOSAL: '05',
};

export const OTHER_PRODUCT_ACTION_STATUS_TYPE = {
  /** 未選択 */
  NOT_ENTERED: '00',
  /** 可能性あり */
  HAVE_POSSIBILITY: '81',
  /** 対応中 */
  IN_PROCESS: '01',
  /** 対応完了 */
  COMPLETE: '91',
};

/** メールパーミッション区分 */
export const MAIL_PERMISSION_TYPE = {
  /** 送信しない */
  NOT_SEND: '',
  /** 拒否 */
  DENY: '00',
  /** 承諾 */
  CONSENT: '01',
  /** 拒否（遠隔） */
  DENY_REMOTE: '10',
  /** 承諾（遠隔） */
  CONSENT_REMOTE: '11',
  /** 回答待ち（遠隔） */
  WAITING_FOR_ANSWER: '19',
} as const;
export type MailPermissionType = typeof MAIL_PERMISSION_TYPE[keyof typeof MAIL_PERMISSION_TYPE];

/** 送信方法 */
export const SEND_TYPE = {
  /** 個別 */
  UNICAST: '0',
  /** 一斉 */
  MULTICAST: '1',
  /** 許諾 */
  OPT_IN: '2',
} as const;
export type SendMethodType = typeof SEND_TYPE[keyof typeof SEND_TYPE];

/** オプトインメールタイプ */
export const OPT_IN_MAIL_TYPE = {
  /** 新規登録 */
  NEW: '0',
  /** 情報更新 */
  UPDATE: '1',
} as const;
export type OptInMailType = typeof OPT_IN_MAIL_TYPE[keyof typeof OPT_IN_MAIL_TYPE];

/** 処理区分 */
export const PROCESSING_TYPE = {
  /** 下書き */
  DRAFT: '0',
  /** 送信 */
  SEND: '1',
} as const;
export type ProcessingType = typeof PROCESSING_TYPE[keyof typeof PROCESSING_TYPE];

/** 主副関係区分 */
export const SUBORDINATION_TYPE = {
  /** SBとの組み合わせ店舗 */
  COMBINED_STORE_WITH_SB: '0',
  /** YMとの組み合わせ店舗 */
  COMBINED_STORE_WITH_YM: '1',
};

/** 企業区分 */
export const COMPANY_CFC = {
  /** SB */
  SB: '1',
  /** YM */
  YM: '4',
};

/** モバイル契約形態区分 */
export const MOBILE_CONTRACT_TYPE = {
  /** 未選択 */
  NOT: '00',
  /** 純新規 */
  NEW: '01',
  /** 乗換（転入） */
  MNP: '02',
  /** 機変 */
  MODEL_CHANGE: '03',
  /** 契約変更 */
  CONTRACT_CHANGE: '04',
  /** 番号移行 */
  MSN_TRANSFER: '05',
  /** 操作説明 */
  OPERATION_EXPLANATION: '06',
  /** 情変 */
  INFO_CHANGE: '07',
  /** 解約阻止 */
  CANCELLATION_PREVENTION: '08',
  /** 転出阻止 */
  MOVING_OUT_PREVENTION: '09',
  /** SIM交換 */
  SIM_CHANGE: '10',
  /** SIM再発行 */
  SIM_REPUBLISH: '11',
  /** その他 */
  OTHER: '99',
};

/** 事前準備架電 */
export const BEF_CALL_TYPE = {
  /** 未実施 */
  NOT_IMPLEMENTED: '0',
  /** 実施済 */
  PERFORMED: '1',
  /** 不要 */
  UN_NECESSARY: '2',
  /** 再架電 */
  RE_CALL: '3',
};

/** 事前準備クルーヒアリング */
export const HEARING_TYPE = {
  /** 未実施 */
  NOT_IMPLEMENTED: '0',
  /** 実施済 */
  PERFORMED: '1',
  /** 不要 */
  UN_NECESSARY: '2',
  /** 対象外 */
  NOT_APPLICABLE: '9',
};

/** 事前準備照会 */
export const REF_AGREE_STATUS_TYPE = {
  /** 同意する */
  CONSENT: '0',
  /** 同意しない */
  DISAGEEMENT: '1',
  /** 未確認 */
  UN_CONFIRMED: '2',
  /** 対象外 */
  NOT_APPLICABLE: '3',
};

/** 事前の動画視聴有無フラグ */
export const WATCH_VIDEO_FLG_TYPE = {
  /** 未実施 */
  NOT_IMPLEMENTED: '0',
  /** 済 */
  DONE: '1',
  /** 一部済 */
  PARTIALLY_DONE: '2',
};

/** 事前顧客照会同意ステータス */
export const REF_CUSTOMER_AGREE_STATUS_TYPE = {
  /** 実施済 */
  PERFORMED: '0',
  /** 未同意 */
  DISAGEEMENT: '1',
  /** 未実施 */
  NOT_IMPLEMENTED: '2',
  /** - */
  NOT_APPLICABLE: '3',
};

/** 予約情報ステータス */
export const STATUS_CD_TYPE = {
  /** 済 */
  DONE: '06',
};

/** 取扱商材区分 */
export const HNDL_ITM_CFC_TYPE = {
  /** 来店予約 */
  VISIT_RESERVATION: '47',
};

/** 初回経路区分 */
export const FIRST_ROUTE_KBN = {
  /** 先頭2桁 */
  FIRST_TOW_DIGITS: {
    /** クルー */
    CREW: 'CR',
  },
};

/** 当日変更フラグ */
export const TODAY_CHG_FLG = {
  /** 当日変更なし */
  NOT_TODAY: '0',
  /** 当日変更あり */
  TODAY: '1',
};

export const WEB_INDENTIFICATION_TYPE = {
  /** クルー */
  CREW_NOT_TODAY: '00',
  /** 当日クルー */
  CREW_TODAY: '01',
  /** WEB */
  WEB_NOT_TODAY: '10',
  /** 当日クルー */
  WEB_TODAY: '11',
};

/** 料金プラン（S） */
export const PRICE_PLAN_TYPE = {
  /** 未選択 */
  NOT_ENTERED: '00',
  /** 基本プラン（音声） */
  AUDIO: '01',
  /** 基本プラン（データ） */
  DATA: '02',
  /** 基本プラン（みまもりケータイ/キッズフォン） */
  WATCH_OVER_KIDS_PHONE: '03',
  /** スマホデビュープラン */
  SMART_PHONE_DEBUT_PLAN: '04',
  /** その他 */
  OTHER: '05',
  /** 未定 */
  TO_BE_DECIDED: '06',
  /** スマホデビュープラン＋ */
  SMART_PHONE_DEBUT_PLAN_PULS: '07',
};

/** 見込顧客モバイル料金プラン区分（Yｍ） */
export const YM_PRICE_PLAN_TYPE = {
  /** 未選択 */
  NOT_ENTERED: '00',
  /** （新規受付終了）シンプルS */
  SIMPLE_S: '01',
  /** （新規受付終了）シンプルM */
  SIMPLE_M: '02',
  /** （新規受付終了）シンプルL */
  SIMPLE_L: '03',
  /** （新規受付終了）ケータイプランSS */
  CELL_PHONE_PLAN_SS: '04',
  /** シェアプラン */
  SHARE_PLAN: '05',
  /** PocketWi-Fiプラン2 */
  POCKET_WI_FI_PLAN_TWO: '06',
  /** （新規受付終了）データプランL/S */
  DATA_PLAN_L_S: '07',
  /** （新規受付終了）スマホプランS */
  SMART_PHONE_PLAN_S: '08',
  /** （新規受付終了）スマホプランM */
  SMART_PHONE_PLAN_M: '09',
  /** （新規受付終了）スマホプランR */
  SMART_PHONE_PLAN_R: '10',
  /** （新規受付終了）スマホプランL */
  SMART_PHONE_PLAN_L: '11',
  /** （新規受付終了）PocketWi-Fiプラン2ライト */
  POCKET_WI_FI_PLAN_TWO_LIGHT: '12',
  /** （新規受付終了）旧PocketWi-Fiプラン */
  OLD_POCKET_WI_FI_PLAN: '13',
  /** （新規受付終了）ケータイプランSプラン（PHS） */
  CELL_PHONE_PLAN_S_PHS: '14',
  /** シンプル2 S */
  SIMPLE_TWO_S: '15',
  /** シンプル2 M */
  SIMPLE_TWO_M: '16',
  /** シンプル2 L */
  SIMPLE_TWO_L: '17',
  /** （新規受付終了）ケータイベーシックプランSS */
  CELL_PHONE_BASIC_PLAN_SS: '18',
  /** 未定 */
  TO_BE_DECIDED: '88',
  /** その他 */
  OTHER: '99',
};

/** パケットサービス（S） */
export const PACKET_DSCT_SERVICE_TYPE = {
  /** 未選択 */
  NOT_ENTERED: '00',
  /** （新規受付停止）データプランメリハリ無制限 */
  DATA_PLAN_MEIRIHARI_UNLIMITED: '01',
  /** データプランミニフィット＋ */
  DATA_PLAN_MINI_FIT_PULS: '02',
  /** データプランメリハリ */
  DATA_PLAN_MERIHARI: '03',
  /** データプランミニフィット */
  DATA_PLAN_MINI_FIT: '04',
  /** データプラン50GB＋ */
  DATA_PLAN_FIFTY_GB_PULS: '05',
  /** データプランミニ */
  DATA_PLAN_MINI: '06',
  /** データプラン1GB */
  DATA_PLAN_ONE_GB: '07',
  /** データプラン1GB+1GBプラス */
  DATA_PLAN_ONE_GB_PULS: '08',
  /** データプラン100MB */
  DATA_PLAN_HUNDRED_MB: '09',
  /** シェア（子回線） */
  SHARE_CHILD_LINE: '10',
  /** その他パケット */
  OTHER_PACKET: '11',
  /** 不要 */
  UN_NECESSARY: '12',
  /** 未定 */
  TO_BE_DECIDED: '13',
  /** データプラン4GB */
  DATA_PLAN_FOUR_GB: '14',
  /** データプラン20GB */
  DATA_PLAN_TWENTY_GB: '15',
  /** データプランペイトク30 */
  DATA_PLAN_PAY_TOKU_THIRTY: '16',
  /** データプランペイトク50 */
  DATA_PLAN_PAY_TOKU_FIFTY: '17',
  /** データプランペイトク無制限 */
  DATA_PLAN_PAY_TOKU_UNLIMITED: '18',
  /** データプランメリハリ無制限＋ */
  DATA_PLAN_MERIHARI_UNLIMITED_PULS: '19',
};

/** 外部連携システムコード */
export const SYSTEM_CD = {
  /** GINIE */
  GINIE: 'M00002',
  /** 来店予約 */
  VISIT_RESERVATION: 'M00500',
  /** 料金シミュレータ */
  FEE_SIMULATOR: 'M00807',
};
/**
 * 前半終了回数
 */
export const MOBILE_INSTALL_EARLY_LAST_COUNT = {
  /** 1～24回 */
  TWENTY_FOUR: '24',
  /** 1～12回 */
  TWELVE: '12',
} as const;
export type PcmCdDivision = typeof MOBILE_INSTALL_EARLY_LAST_COUNT[keyof typeof MOBILE_INSTALL_EARLY_LAST_COUNT];

/**
 * チェック状態
 * チェックボックス・ラジオなどチェック状態を表す
 */
export const CHECK_FLG = {
  ON: '1',
  OFF: '0',
};

export const removeProductVariableOfMobile = (
  selectedCategoryType: string,
  registrationProductList: Array<RegistrationProduct>
): Array<RegistrationProduct> => {
  return nonMobileCategoryType.includes(selectedCategoryType)
    ? registrationProductList.filter((product) => displayItemIdListNeedRemoved.indexOf(product.displayItemId) === -1)
    : registrationProductList;
};

export const displayItemIdListNeedRemoved: string[] = [
  DISPLAY_ITEM_ID.MOBILE_UPD_YEAR_MONTH,
  DISPLAY_ITEM_ID.MOBILE_INSTALL_MONTHLY_PAYMENT,
  DISPLAY_ITEM_ID.MOBILE_INSTALL_END_YEAR_MONTH,
  DISPLAY_ITEM_ID.USING_MOBILE_INSTALL_MONTHLY_PAYMENT_EARLY,
  DISPLAY_ITEM_ID.USING_MOBILE_INSTALL_EARLY_LAST_COUNT,
  DISPLAY_ITEM_ID.USING_MOBILE_KIND_NAME,
  DISPLAY_ITEM_ID.SUBSCRIPTION_BENEFITS,
  DISPLAY_ITEM_ID.CAMPAIGN_START_MONTH,
  DISPLAY_ITEM_ID.USING_MOBILE_INSTALL_END_YEAR_MONTH_EARLY,
];

export const nonMobileCategoryType: string[] = [
  COMMODITY_CATEGORY_TYPE.SOFTBANK_HIKARI,
  COMMODITY_CATEGORY_TYPE.SOFTBANK_AIR,
  COMMODITY_CATEGORY_TYPE.ELECTRICITY,
  COMMODITY_CATEGORY_TYPE.HOME_PHONE,
  COMMODITY_CATEGORY_TYPE.ALL_OTHER,
];

/**
 * 許諾メール再送信フラグ
 */
export const OPT_IN_MAIL_RESEND_FLG = {
  /** 送信しない */
  NOT_SEND: '0',
  /** 送信する */
  SEND: '1',
} as const;
export type OptinMailResendFlg = typeof OPT_IN_MAIL_RESEND_FLG[keyof typeof OPT_IN_MAIL_RESEND_FLG];

/**
 * 遷移元画面の種別
 */
export const TRANSITION_SOURCE_PAGE_STATE = {
  /**
   * ダッシュボードからの遷移
   */
  DASHBOARD: 'innerSiteDashboard',
  /**
   * 商談一覧からの遷移
   */
  SEARCH_RESULT: 'innerSiteSearchResult',
  /**
   * お客さま情報からの遷移
   */
  CUSTOMER_DETAIL: 'innerSiteCustomerDetail',
  /**
   * サマリーからの遷移
   */
  SUMMARY: 'innerSiteSummary',
  /**
   * 外部サイトからの遷移
   */
  EXTERNAL: 'external',
} as const;
export type TransitionSourcePageType = typeof TRANSITION_SOURCE_PAGE_STATE[keyof typeof TRANSITION_SOURCE_PAGE_STATE];

export type DataLayer = 'customer' | 'negotiation';

export type ErrorMessageType = {
  /**
   * エラー概要のタイトル
   */
  errorTitle: string;
  /**
   * エラー補足情報
   */
  errorMessageList: string[];
};

/**
 * backendとの疎通が想定外の原因により失敗した場合に使用するメッセージの共通文言
 */
export const API_EXCEPTION_MSG = `API通信時に異常が発生しました`;

export const notfoundTitleBaseStr = `{0}が見つかりませんでした`;
const notfoundMessageBaseStr = `指定された{0}が削除されています`;
const directingNextActionMessageBaseStr = `もう一度商談一覧から検索しなおしてください`;
export const displayCustomerInfo = 'お客さま情報';
export const displayNegotiationInfo = '商談情報';
const DATA_NOT_FOUND_MESSAGE_MAP: ReadonlyMap<DataLayer, ErrorMessageType> = new Map<DataLayer, ErrorMessageType>([
  [
    'customer',
    {
      errorTitle: getReplacedStringByParams(notfoundTitleBaseStr, displayCustomerInfo),
      errorMessageList: [getReplacedStringByParams(notfoundMessageBaseStr, displayCustomerInfo), directingNextActionMessageBaseStr],
    },
  ],
  [
    'negotiation',
    {
      errorTitle: getReplacedStringByParams(notfoundTitleBaseStr, displayNegotiationInfo),
      errorMessageList: [getReplacedStringByParams(notfoundMessageBaseStr, displayNegotiationInfo), directingNextActionMessageBaseStr],
    },
  ],
]);

export const getDataNotFoundMessageObject = (key: DataLayer): ErrorMessageType =>
  DATA_NOT_FOUND_MESSAGE_MAP.get(key) ?? {
    errorTitle: '',
    errorMessageList: [],
  };

export const SESSION_STORAGE_NEGOTATION_KEYS = {
  SORT_TYPE: 'sort-business',

  CURRENT_PAGE: 'current-page-business',

  PAGING_TABLE: 'paging-table',

  API_UPDATE_INDEX: 'api-update-index',
};

export const getStorageValueByKey = (key: string) => {
  const value = window.sessionStorage.getItem(key) as string;
  return value;
};

export const setStorageValueByKey = (key: string, value: any) => {
  let _value = value;
  if (typeof value !== 'string') {
    _value = JSON.stringify(value);
  }
  window.sessionStorage.setItem(key, _value);
};

export const removeKeysStorage = () => {
  const arrKeys = [
    SESSION_STORAGE_NEGOTATION_KEYS.API_UPDATE_INDEX,
    SESSION_STORAGE_NEGOTATION_KEYS.CURRENT_PAGE,
    SESSION_STORAGE_NEGOTATION_KEYS.PAGING_TABLE,
    SESSION_STORAGE_NEGOTATION_KEYS.SORT_TYPE,
  ];
  arrKeys.forEach((item) => sessionStorage.removeItem(item));
};

export const EVENT_LISTENER_KEYS = {
  BEFORE_UNLOAD: 'beforeunload',
};

export const BRANCH_CONDITTION_KEY = {
  COMMODITY_CATEGORY_TYPE: 'commodityCategoryType',
  UNDISPFLAG: 'undispFlg',
  NEGOTIATIONRESULTTYPE: 'negotiationResultType',
  RESURRECTION_FLG: 'resurrectionFlg',
  ACTION_DATE: 'actionDate',
  ACTION_INFOR: 'actionInfo',
  MOBILE_CONTRACT_TYPE: 'mobileContractType',
  PRODUCT_INFO: 'productInfo',
  DUMMY_FLG: 'dummyFlg',
  ACTION_TYPE: 'actionType',
  DOC_TYPE: 'docType',
  CONTRACT_ACCURACY_TYPE: 'contractAccuracyType',
};

export const NON_FILTER_BRANCHCONDITTION_KEYS: string[] = [
  BRANCH_CONDITTION_KEY.UNDISPFLAG,
  BRANCH_CONDITTION_KEY.ACTION_INFOR,
  BRANCH_CONDITTION_KEY.PRODUCT_INFO,
  BRANCH_CONDITTION_KEY.DUMMY_FLG,
];

export enum GTM_BUTTON_ID {
  EMPLOYEE_SEARCH_BUTTON_ID = 'employee-search-button',
}

export const SALE_MANCD_NAME_KEY = {
  CLOSING_SALE_MANCD: 'closingSalesmanName',
  MAIN_CLOSING_SALE_MANCD: 'mainClosingSalesmanName',
};
